import React from 'react';
import { Message } from '@alifd/next';
import classnames from 'classnames';
import { fixedMessage } from './index.module.scss';

const methods = ['show', 'success', 'warning', 'error', 'notice', 'help', 'loading'];

// 为了把messge fix起来
for (let method of methods) {
  if (method in Message) {
    const originMethod = Message[method];
    Message[method] = (config: any) => {
      if (Object.prototype.toString.call(config) === '[object Object]') {
        config = {
          ...config,
          className: classnames(fixedMessage, { [config?.className]: config?.className }),
        };
      } else if (typeof config === 'string' || React.isValidElement(config)) {
        config = { title: config, className: fixedMessage };
      }
      originMethod.call(null, config);
    };
  }
}
